import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import BannerHeader from 'components/Client/BannerHeader/BannerHeader'
import BannerBalance from 'components/Client/BannerHeader/BannerBalance/BannerBalance'
import PortfolioOverview from 'components/Client/PortfolioOverview/PortfolioOverview'
import HoldingsList from 'components/Client/HoldingsList/HoldingsList'
import withTechnicalDifficultiesErrorMessage from 'components/Client/withTechnicalDifficultiesErrorMessage'
import withLoadingState from '../withLoadingState'
import LoadingComponent from 'components/Client/LoadingComponent/LoadingComponent'

const PortfolioPage = (props) => {
  const {
    primaryPortfolio,
    primaryPortfolio: { holdings, totalEmv },
    loadingPortfolioHoldings,
    blackDiamondError,
    isMobile,
  } = props

  const HeaderComponent = (
    <BannerHeader>
      <BannerBalance
        text="TOTAL PORTFOLIO VALUE"
        balance={totalEmv} />
    </BannerHeader>
  )

  const HoldingsListComponent = <HoldingsList isMobile={isMobile} holdings={holdings} />
  const HoldingsListWithLoading = withLoadingState(HoldingsListComponent, <LoadingComponent />)
  const BlackDiamondComponents = (
    <Fragment>
      {HeaderComponent}
      <PortfolioOverview primaryPortfolio={primaryPortfolio} />
      <HoldingsListWithLoading loading={loadingPortfolioHoldings} />
    </Fragment>
  )
  const PortfolioPageContent = withTechnicalDifficultiesErrorMessage(BlackDiamondComponents)

  return (
    <Fragment>
      <PortfolioPageContent showError={blackDiamondError} context={'portfolio'} layout="page" />
    </Fragment>
  )
}

PortfolioPage.defaultProps = {
  primaryPortfolio: {},
  blackDiamondError: false,
  loadingPortfolioHoldings: false,
  isMobile: false,
}

PortfolioPage.propTypes = {
  primaryPortfolio: PropTypes.object,
  blackDiamondError: PropTypes.bool,
  loadingPortfolioHoldings: PropTypes.bool,
  isMobile:  PropTypes.bool,
}

export default PortfolioPage



// WEBPACK FOOTER //
// ./src/components/Client/PortfolioPage/PortfolioPage.jsx